import { Component, OnInit, Injector, ComponentFactoryResolver, ViewContainerRef } from '@angular/core';


/** Services */
import { BaseService } from '../../shared/services/base.service';
import { AppService } from '../../shared/services/app.service';
import { AlertsService } from '../../services/alerts.service';
import { LoaderService } from '../../services/loader.service';
import { SmartModalService,ModalSize } from '../../services/smart-modal.service';
import { ModalService } from '../../services/modal.service';
import { RolePermissionService } from '../../shared/services/role-permission.service'
import { CommunicationService } from '../../services/communication.service';
import { ActivatedRoute } from '@angular/router';
import { StorageService } from '../../shared/services/storage.service';
import { FormService } from '../form/form.service';
import { TranslateService } from '../../services/translate.service';
import { MessagingService } from '../../shared/services/messaging.service';
import { PrintService } from '../../shared/services/print.service';
import { AuthenticationService } from '../../shared/services/authentication.service';
import { FilterService } from '../../services/filter.service';
import { UtilService } from '../../services/util.service';
import { DialogService } from '../dialog/dialog.service';
import { DialogRef } from '../dialog/dialog-ref';
import { PreferenceService } from '../../shared/services/preference.service';
import { RuleEngineService } from '../../shared/services/ruleengine.service';
import { Location } from '@angular/common';
import { DownloadService } from '../../shared/services/download.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { AIService } from '../aiml/services/ai.service';
import { BarcodeGridScanService } from '../../services/barcode-grid-scan.service';

/** Services */
@Component({
    selector: 'app-main',
    template: '<div></div>',
    standalone: false
})
export class MainComponent implements OnInit {
  public baseService: any;
  public locationCommon: any;
  public appService: any;
  public alerts: any;
  public messagingService: any;
  public translateService: any;
  public authenticationService:any;
  public printService: any;
  public resouceMapperService: any;
  public smartModalService: SmartModalService;
  public modalService: ModalService;
  public loader: LoaderService; 
  public rolePermissionService: any;
  public communicationService: CommunicationService;
  public startRoute: string;
  public storageService: StorageService;
  public formService: FormService;
  public _componentFactoryResolver: ComponentFactoryResolver;
  public viewContainerRef: ViewContainerRef;
  public filterService:FilterService;
  public utilService: UtilService;
  public dialogService: DialogService
  public dialogRef: DialogRef;
  public bsModalRef: BsModalRef
  public preferenceService: PreferenceService;
  public ruleEngineService: RuleEngineService;
  public downloadService: DownloadService;
  public aiService: AIService;
  public barcodeGridScanService: BarcodeGridScanService;

  breadcrumbs: any[];
  public bsModalService: BsModalService;
  
  constructor(
    public injector: Injector,
    public activatedRoute: ActivatedRoute,
    // private moda: BsModalService
  ) {
    this.dialogRef = injector.get(DialogRef);
    this.bsModalRef = injector.get(BsModalRef);
    this.baseService = injector.get(BaseService);
    this.formService = injector.get(FormService);
    this.appService = injector.get(AppService);
    this.alerts = injector.get(AlertsService);
    this.loader = injector.get(LoaderService);
    this.utilService  = injector.get(UtilService);
    this.smartModalService = injector.get(SmartModalService);
    this.bsModalService = injector.get(BsModalService);
    this.modalService = injector.get(ModalService);
    this.printService = injector.get(PrintService);
    this.rolePermissionService = injector.get(RolePermissionService);
    this.communicationService = injector.get(CommunicationService);
    this.storageService = injector.get(StorageService);
    this.messagingService = injector.get(MessagingService);
    this.translateService = injector.get(TranslateService);
    this.authenticationService = injector.get(AuthenticationService);
    this.dialogService = injector.get(DialogService);
    this.barcodeGridScanService = injector.get(BarcodeGridScanService);
    const root: ActivatedRoute = this.activatedRoute.root;
    this.startRoute = this.appService._appData.DEFAULT_APPLICATION+'/dashboard'; // This is fixed start root, need to be optimized.
    this.communicationService.emitChange({ breadcrumbs: this.breadcrumbs });
    this.filterService = injector.get(FilterService);
    this.preferenceService = injector.get(PreferenceService);
    this.ruleEngineService = injector.get(RuleEngineService);
    this.locationCommon = injector.get(Location);
    this.downloadService = injector.get(DownloadService);
    this.aiService = injector.get(AIService);
  }

  ngOnInit() {

  }

  capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.toLowerCase().slice(1);
  }
}